import { render, staticRenderFns } from "./leave-register.vue?vue&type=template&id=f5f3cb28&"
import script from "./leave-register.vue?vue&type=script&lang=js&"
export * from "./leave-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports